import * as Sentry from '@sentry/browser';

// Create a browser-compatible logger
class BrowserLogger {
  private static formatMessage(level: string, message: string, meta?: any) {
    const timestamp = new Date().toISOString();
    return `[${timestamp}] ${level.toUpperCase()}: ${message}${meta ? ' ' + JSON.stringify(meta) : ''}`;
  }

  info(message: string, meta?: any) {
    console.log(BrowserLogger.formatMessage('info', message, meta));
  }

  warn(message: string, meta?: any) {
    console.warn(BrowserLogger.formatMessage('warn', message, meta));
  }

  error(message: string, meta?: any) {
    console.error(BrowserLogger.formatMessage('error', message, meta));
    
    // Send errors to Sentry in production
    if (import.meta.env.PROD) {
      Sentry.captureMessage(message, {
        level: Sentry.Severity.Error,
        extra: meta
      });
    }
  }

  debug(message: string, meta?: any) {
    if (import.meta.env.DEV) {
      console.debug(BrowserLogger.formatMessage('debug', message, meta));
    }
  }
}

export const logger = new BrowserLogger();